import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Get token from localStorage
const getToken = () => localStorage.getItem('admin_token');

// Set token in request headers
const getAuthHeaders = () => ({
  headers: {
    'Authorization': `Bearer ${getToken()}`
  }
});

// Auth API
export const authAPI = {
  login: async (email, password) => {
    const response = await axios.post(`${API_BASE}/auth/login`, { email, password });
    return response.data;
  },
  
  verify: async () => {
    const response = await axios.post(`${API_BASE}/auth/verify`, {}, getAuthHeaders());
    return response.data;
  }
};

// Quotes API
export const quotesAPI = {
  getAll: async (status = null) => {
    const params = status && status !== 'all' ? { status } : {};
    const response = await axios.get(`${API_BASE}/quotes`, { 
      ...getAuthHeaders(), 
      params 
    });
    return response.data;
  },
  
  create: async (quoteData) => {
    const response = await axios.post(`${API_BASE}/quotes`, quoteData, getAuthHeaders());
    return response.data;
  },
  
  update: async (id, quoteData) => {
    const response = await axios.put(`${API_BASE}/quotes/${id}`, quoteData, getAuthHeaders());
    return response.data;
  },
  
  updateStatus: async (id, status) => {
    const response = await axios.patch(`${API_BASE}/quotes/${id}/status`, { status }, getAuthHeaders());
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/quotes/${id}`, getAuthHeaders());
    return response.data;
  }
};

// Revenue API
export const revenueAPI = {
  getStats: async (year = null) => {
    const params = year ? { year } : {};
    const response = await axios.get(`${API_BASE}/revenue/stats`, {
      ...getAuthHeaders(),
      params
    });
    return response.data;
  },
  
  exportCSV: async (year = null) => {
    const params = year ? { year } : {};
    const response = await axios.get(`${API_BASE}/revenue/export`, {
      ...getAuthHeaders(),
      params,
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `revenus_${year || 'all'}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};

// Blog API
export const blogAPI = {
  // Public endpoints
  getPosts: async (page = 1, limit = 10) => {
    const response = await axios.get(`${API_BASE}/blog/posts`, {
      params: { page, limit }
    });
    return response.data;
  },
  
  getPostBySlug: async (slug) => {
    const response = await axios.get(`${API_BASE}/blog/posts/${slug}`);
    return response.data;
  },
  
  // Admin endpoints
  getAllPosts: async () => {
    const response = await axios.get(`${API_BASE}/blog/admin/posts`, getAuthHeaders());
    return response.data;
  },
  
  createPost: async (postData) => {
    const response = await axios.post(`${API_BASE}/blog/admin/posts`, postData, getAuthHeaders());
    return response.data;
  },
  
  updatePost: async (id, postData) => {
    const response = await axios.put(`${API_BASE}/blog/admin/posts/${id}`, postData, getAuthHeaders());
    return response.data;
  },
  
  deletePost: async (id) => {
    const response = await axios.delete(`${API_BASE}/blog/admin/posts/${id}`, getAuthHeaders());
    return response.data;
  }
};

// Contact API
export const contactAPI = {
  submit: async (contactData) => {
    const response = await axios.post(`${API_BASE}/contact/submit`, contactData);
    return response.data;
  }
};
